import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, User } from "lucide-react";
import { Avatar, Menu as MuiMenu, MenuItem, IconButton } from "@mui/material";
import { useAuth } from "../context/AuthContext"; // ใช้ context ตรวจสอบ login
import logo from "../assets/logos/logo_ai.jpg"; // Logo สำหรับไม่ล็อกอิน
import logoewy from "../assets/logos/logo_ewy.png"; // Logo สำหรับล็อกอิน
import "./Header.css";

const Header = ({ isOpen, toggleSidebar }) => {
  const { user, isAuthenticated, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const location = useLocation(); // ใช้ useLocation เพื่อตรวจสอบ URL ปัจจุบัน


  useEffect(() => {
    setAnchorEl(null); // รีเซ็ต anchorEl ทุกครั้งที่ user เปลี่ยน
  }, [user]);

  const handleMenuOpen = (event) => {
    // setAnchorEl(event.currentTarget);
    setAnchorEl(event.currentTarget);
    // setTimeout(() => setAnchorEl(event.currentTarget), 100);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const getLogoAndName = () => {
    if (isAuthenticated) {
      // ตรวจสอบหลาย path
      if (location.pathname === "/smartfactory") {
        return {
          logo: logoewy,
          name: "Smart Factory Platform"
        };
      } else if (location.pathname === "/another-path") {
        return {
          logo: logoewy,
          name: "Custom Page 2"
        };
      } else {
        return {
          logo: logoewy,
          name: "FAP : Financial Reconciliation"
        };
      }
    } else {
      return {
        logo: logo,
        name: "Financial Analytics Platform"
      };
    }
  };

  const { logo: logoToDisplay, name: systemName } = getLogoAndName();

  return (
    <div className="header">
      {/* === ซ้าย: ปุ่มเปิด Sidebar === */}
      <div className="header-left">
        <button className="menu-button" onClick={toggleSidebar}>
          <Menu size={24} strokeWidth={1} />
        </button>
      </div>

      {/* === กลาง: Logo และชื่อระบบ === */}
      <div className="header-center">
        <Link to="/" className="logo-container">
          <img src={logoToDisplay} alt="AISCIMER COMPANY LIMITED" className="logo" />
          <h1 className="system-name">{systemName}</h1>
        </Link>
      </div>

      {/* === ขวา: ปุ่ม Login หรือ Avatar ถ้าล็อกอินแล้ว === */}
      <div className="header-right">
        {isAuthenticated ? (
          <>
            {/* Avatar สำหรับ user ที่ล็อกอินแล้ว */}
            <IconButton onClick={handleMenuOpen}>
              <Avatar sx={{ bgcolor: "primary.main", width: 30, height: 30 }}>
                {user?.username?.charAt(0).toUpperCase()}
              </Avatar>
            </IconButton>

            {/* เมนู dropdown */}
            <MuiMenu
              anchorEl={document.body.contains(anchorEl) ? anchorEl : null}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              {/* <MenuItem onClick={handleMenuClose}>Profile</MenuItem> */}
              <MenuItem
                onClick={() => {
                  setAnchorEl(null); // รีเซ็ตค่า anchorEl
                  logout(); // เรียกฟังก์ชัน logout
                }}
              >
                Logout
              </MenuItem>
            </MuiMenu>
          </>
        ) : (
          <Link to="/login" className="sign-in-button">
            <User size={20} strokeWidth={1} />
            <span>Login</span>
          </Link>
        )}
      </div>
    </div>
  );
};

export default Header;
